import { createFileRoute } from "@tanstack/react-router";
import { PayoutsPage } from "@/features/freelancersmore/PayoutsPage";

export const Route = createFileRoute("/_app/freelancers/payouts")({
  component: () => <PayoutsPage />,
});
